import { Fragment, ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { ArrowRightIcon } from '@10xLabs/react-web/components/Icons/ArrowRight'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { TableContainer, Table, Thead, Tbody, Tr } from '@10xLabs/react-web/components/Table'
import { Wrapper, MainTd, MainTh, MainTr, DetailsTr, DetailsTd } from 'components/NestedTable'
import { PassengersList } from '../PassengersList'
import { GTTripBookings } from 'gql/types.generated'

const AlignCenter = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
`

const UpDownIndicator = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  margin-right: 2px;

  svg {
    width: 14px;
    height: 14px;
  }
`

const Up = styled(UpDownIndicator)<TSFixMe>`
  color: #66bb6a;
  display: flex;

  svg {
    fill: #66bb6a;
    transform: rotate(-90deg);
  }
`

const Down = styled(UpDownIndicator)<TSFixMe>`
  color: #b0497e;

  svg {
    fill: #b0497e;
    transform: rotate(90deg);
  }
`

interface IStopsListProps {
  tripBookings: GTTripBookings
}

export const StopsList = ({ tripBookings }: IStopsListProps): ReactElement => {
  const intl = useIntl()

  return (
    <Wrapper>
      <TableContainer overflow>
        <Table>
          <Thead>
            <Tr>
              <MainTh>
                <FormattedMessage id="trip.passengers.mainTable.stop.header" defaultMessage="Stop" />
              </MainTh>
              <MainTh>
                <FormattedMessage id="trip.passengers.mainTable.departureTime.header" defaultMessage="Departure time" />
              </MainTh>
              <MainTh>
                <FormattedMessage id="trip.passengers.mainTable.passengers.header" defaultMessage="Passengers" />
              </MainTh>
            </Tr>
          </Thead>

          <Tbody>
            {tripBookings.itinerary.map((tripSegmentBookings, index: number): ReactElement => {
              return (
                <Fragment key={index}>
                  <MainTr isDetailsOpen>
                    <MainTd>{tripSegmentBookings.origin.name}</MainTd>
                    <MainTd>
                      <FormattedTimeByDate
                        intl={intl}
                        date={tripSegmentBookings.departureAt}
                        timeZone={tripSegmentBookings.origin.timezone || undefined}
                      />
                    </MainTd>
                    <MainTd>
                      <AlignCenter>
                        <Up>
                          <ArrowRightIcon />
                          {tripSegmentBookings.passengers.up}
                        </Up>
                        &nbsp;
                        <Down>
                          <ArrowRightIcon />
                          {tripSegmentBookings.passengers.down}
                        </Down>
                      </AlignCenter>
                    </MainTd>
                  </MainTr>
                  <DetailsTr>
                    <DetailsTd colSpan={3}>
                      <PassengersList tripSegmentBookings={tripSegmentBookings} />
                    </DetailsTd>
                  </DetailsTr>
                </Fragment>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Wrapper>
  )
}
